export default {
  name: 'PzOfertaDownSolicitudUy',
  inject: ['myForm'],
  data: function data() {
    return {
      picked: 'One'
    };
  },
  mounted: function mounted() {}
};